import { useState } from "react";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragOverlay } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy } from "@dnd-kit/sortable";
import { restrictToWindowEdges } from "@dnd-kit/modifiers";
import { SortableItem, ImageItemContent } from "./SortableItem";
import { useMediaQuery, useTheme } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import Box from "@mui/system/Box";

const ImageListRow = ({ imageList = [], setImageList, handleModalOpen = () => {}, handleDeleteImage = () => {}, handleReorder = () => {} }) => {
    const [activeId, setActiveId] = useState(null);
    const theme = useTheme();

    /**
     * Custom sensor that ignores button clicks
     * distance - Minimum movement to activate draga on button
     */
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragStart = (event) => {
        setActiveId(event.active.id);
    };

    const handleDragEnd = (event) => {
        //If the opposition has not changed, do not run reorder
        if (event?.delta?.x == 0 && event?.delta?.y == 0) {
            return;
        }
        const { active, over } = event;
        if (active.id !== over?.id) {
            const oldIndex = imageList.findIndex((item) => item.id === active.id);
            const newIndex = imageList.findIndex((item) => item.id === over.id);

            const newItems = arrayMove(imageList, oldIndex, newIndex);
            setImageList(newItems);
            handleReorder(active.id, newIndex + 1);
        }
        setActiveId(null);
    };

    const activeItem = activeId ? imageList.find((item) => item.id === activeId) : null;
    const isXl = useMediaQuery(theme.breakpoints.up("xl"));

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd} modifiers={[restrictToWindowEdges]}>
            <SortableContext items={imageList.map((item) => item.id)} strategy={rectSortingStrategy}>
                <ImageList sx={{ overflow: "visible", width: "100%" }} cols={isXl ? 5 : 4}>
                    {imageList.map((item) => (
                        <SortableItem key={item.id} id={item.id} item={item} handleModalOpen={handleModalOpen} handleDeleteImage={handleDeleteImage} />
                    ))}
                </ImageList>
            </SortableContext>

            <DragOverlay>
                {activeItem ? (
                    <Box sx={{ position: "relative", transform: "scale(1.05)", zIndex: 9999 }}>
                        <ImageItemContent item={activeItem} isDragging handleModalOpen={handleModalOpen} handleDeleteImage={handleDeleteImage} />
                    </Box>
                ) : null}
            </DragOverlay>
        </DndContext>
    );
};

export default ImageListRow;
